class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    
    this.attachShadow({ mode: 'open' });
    this.template = this.closest('.shopify-section').querySelector('template');
    this.shadowRoot.appendChild(this.template.content.cloneNode(true));

    this.splide = null;
  }

  connectedCallback() {
    this.initSplide();
  }

  initSplide() {
    const sliderElement = this.shadowRoot.querySelector('.splide');
    
    if (!sliderElement) {
      console.warn('splide element not found');
      return;
    };

    const autoplay = sliderElement.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(sliderElement.dataset.autoplaySpeed) || 5000;

    this.splide = new Splide(sliderElement, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: false,
      autoplay: autoplay,
      interval: autoplaySpeed,
      pauseOnHover: true,
      pauseOnFocus: true,
    });

    this.splide.on('overflow', (isOverflow) => {
      this.splide.options = {
        arrows: isOverflow && sliderElement.dataset.arrows === 'true',
      }
    });

    this.splide.mount();
  }
}

customElements.define('announcement-bar', AnnouncementBar);